import axios from '../api/index.js';

//查询首页轮播列表
export let getBannerQuery = (params) => {
    return axios.post(`/client/rotation/list?dictId=${params}`);
};

//查询首页轮播介绍详情
export let getBannerQueryById = (params) => {
    return axios.get(`/client/rotation/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/banner.js